<script setup lang="ts">
import { AppsPage, redirectMobileToStore } from '@features/apps'

definePageMeta({
  middleware: [
    function () {
      // При заходе на страницу с мобильного устройства система должна понимать платформу девайса и переводить в store с использованием ссылки
      return redirectMobileToStore()
    },
  ],
})
</script>

<template>
  <apps-page />
</template>
